import { getAPIHeaders } from 'src/services/apiRequests/Login/LoginService';
import { httpService } from 'src/services/fetch/HttpService';
import {
  getLocalStorage,
  setLocalStorage
} from 'src/utils/browserStorageHandler';
import { getCurrentTimeStamp } from 'src/utils/common';
import { GUEST_USER_REGISTRATION_URL } from 'src/utils/constants/ApiConstants';
import { GUEST_TOKEN } from 'src/utils/constants/AppConstants';
import { HTTP_METHODS } from 'src/utils/constants/HttpMethodsConstants';
import { GUEST_USER_REG_OBJ } from 'src/utils/constants/localStorageConstants';
import { getGuestUserToken } from 'src/utils/UtilityMethods';

interface GuestUserRegistrationResponseType {
  access_token: string;
  expires_in: number;
  token_type: string;
  refresh_token: string;
  email: string;
}
const fetchGuestUserRegistrationToken = async () => {
  try {
    let guestToken = getLocalStorage(GUEST_TOKEN);
    if (!guestToken || guestToken === 'undefined') {
      guestToken = await getGuestUserToken();
    }

    const requestBody = { guestToken };
    const headers = getAPIHeaders();

    const guestRegistrationResponse: GuestUserRegistrationResponseType =
      await httpService.fetchApiData({
        url: GUEST_USER_REGISTRATION_URL,
        type: HTTP_METHODS.POST,
        body: requestBody,
        headers
      });

    if (
      guestRegistrationResponse &&
      Object.hasOwn(
        guestRegistrationResponse,
        guestRegistrationResponse.expires_in
      )
    ) {
      guestRegistrationResponse.expires_in =
        getCurrentTimeStamp() + guestRegistrationResponse.expires_in;
    }

    setLocalStorage(GUEST_USER_REG_OBJ, guestRegistrationResponse);
    return guestRegistrationResponse?.access_token;
  } catch (error) {
    console.log('Error while performing guest user registration: ', error);
  }
};

export default fetchGuestUserRegistrationToken;
